module.exports = __webpack_public_path__ + "img/66.08e3ad77.svg";